import axios from "axios";

// Set withCredentials on axios before creating instance (if we r working with cookies)
//  axios.defaults.withCredentials = true;

const baseURL = process.env.REACT_APP_ADMIN_CMS_API_URL

const sitecoreAxiosInstance = axios.create({
    baseURL: `${baseURL}`,

    /* on timeout checks request on slow network if request takes too long on slow network then axios cancels it (handle such canceled requests). */
    timeout: 60000, /**1min */
    maxContentLength: 2000
});

/**------------------------------------------------------ */

// Add a request interceptor
/**
 * axios.interceptors.request.use(config_Callback, error)
 */

sitecoreAxiosInstance.interceptors.request.use(

    (request) => {
        /*
          token from persisted store must be accessed here only. otherwise '401:unautherization' error will be produced by axios
        */

        // request.headers['TokenType'] = 'ADB2C';
        request.headers['sc_apikey'] = process.env.REACT_APP_ADMIN_CMS_API_KEY;
        request.headers["Content-Type"] = "application/json";

        return request;
    },
    (error) => {

        console.log('sitecoreAxiosInstance:', error)

        // Do something with request error
        return Promise.reject(error);

    }
);

/**------------------------------------------------------ */


// Add a response interceptor
/**
 * axios.interceptors.response.use(response_Callback, error)
 */
sitecoreAxiosInstance.interceptors.response.use(

    (response) => {
        // Do something after response is received

        // console.log("AXIOSRESP:..", response)

        return response;

    },
    (error) => {
        console.log('sitecoreAxiosInstance:', error)

        // Do something with request error
        return Promise.reject(error);

    }
);

export default sitecoreAxiosInstance;
